import "core-js/modules/es.promise.finally.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Box from "../../../../../Styled/Box";
import { TextSpan } from "../../../../../Styled/Text";
import Button from "../../../../../Styled/Button";
import { downloadImg } from "./PrintView";
import Spacing from "../../../../../Styled/Spacing";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PrintSection = _ref => {
  let {
    viewState
  } = _ref;
  const {
    t
  } = useTranslation();
  const [isDownloading, setIsDownloading] = useState(false);
  const printView = () => {
    const newWindow = window.open();
    viewState.setPrintWindow(newWindow);
  };
  const downloadMap = () => {
    setIsDownloading(true);
    viewState.terria.currentViewer.captureScreenshot().then(dataString => {
      downloadImg(dataString);
    }).finally(() => setIsDownloading(false));
  };
  return /*#__PURE__*/_jsxs(Box, {
    column: true,
    children: [/*#__PURE__*/_jsx(TextSpan, {
      semiBold: true,
      medium: true,
      children: t("share.printTitle")
    }), /*#__PURE__*/_jsx(Spacing, {
      bottom: 1
    }), /*#__PURE__*/_jsx(Explanation, {
      children: t("share.printExplanation")
    }), /*#__PURE__*/_jsx(Spacing, {
      bottom: 1
    }), /*#__PURE__*/_jsxs(Box, {
      gap: 2,
      children: [/*#__PURE__*/_jsx(PrintButton, {
        primary: true,
        fullWidth: true,
        disabled: isDownloading,
        onClick: downloadMap,
        children: /*#__PURE__*/_jsx(TextSpan, {
          medium: true,
          children: t("share.downloadMap")
        })
      }), /*#__PURE__*/_jsx(PrintButton, {
        primary: true,
        fullWidth: true,
        onClick: printView,
        children: /*#__PURE__*/_jsx(TextSpan, {
          medium: true,
          children: t("share.printViewButton")
        })
      })]
    })]
  });
};
const PrintButton = styled(Button).withConfig({
  displayName: "PrintSection__PrintButton",
  componentId: "sc-jddkzj-0"
})(["border-radius:4px;"]);
const Explanation = styled(TextSpan).withConfig({
  displayName: "PrintSection__Explanation",
  componentId: "sc-jddkzj-1"
})(["opacity:0.8;"]);